import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

/**
 * Destructive confirmation for turning the kill-switch OFF. Pure UI — the caller
 * dispatches the toggle so the header pill and the Availability tab can reuse it.
 *
 * No reason input: the BE toggle endpoint accepts only `{ enabled }` (and runs
 * `forbidNonWhitelisted`), so there's nowhere to persist a reason.
 */
@Component({
  selector: 'app-stop-online-ordering-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './stop-online-ordering-dialog.component.html'
})
export class StopOnlineOrderingDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<StopOnlineOrderingDialogComponent, boolean>
  );

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
